<div
    #wrapper
    role="group"
    class="wrapper"
    [formGroup]="units"
    [attr.aria-labelledby]="formField?.getLabelId()"
    (click)="onContainerClick($event)"
    (keyup)="onKeyup($event)"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
>
    <input
        #months
        *ngIf="format.months && units.controls.months"
        class="input"
        formControlName="months"
        aria-label="Months"
        [size]="inputsConfiguration.months.size"
        (input)="onInput(monthsInput)"
    />
    <span *ngIf="inputsConfiguration.months.separator" class="spacer">
        {{inputsConfiguration.months.separator}}
    </span>
    <input
        #days
        *ngIf="format.days && units.controls.days"
        class="input"
        formControlName="days"
        aria-label="Days"
        [size]="inputsConfiguration.days.size"
        (input)="onInput(daysInput)"
    />
    <span *ngIf="inputsConfiguration.days.separator" class="spacer">
        {{inputsConfiguration.days.separator}}
    </span>
    <input
        #hours
        *ngIf="format.hours && units.controls.hours"
        class="input"
        formControlName="hours"
        aria-label="Hours"
        [size]="inputsConfiguration.hours.size"
        (input)="onInput(hoursInput)"
    />
    <span *ngIf="inputsConfiguration.hours.separator" class="spacer">
        {{inputsConfiguration.hours.separator}}
    </span>
    <input
        #minutes
        *ngIf="format.minutes && units.controls.minutes"
        class="input"
        formControlName="minutes"
        aria-label="Minutes"
        [size]="inputsConfiguration.minutes.size"
        (input)="onInput(minutesInput)"
    />
    <span *ngIf="inputsConfiguration.minutes.separator" class="spacer">
        {{inputsConfiguration.minutes.separator}}
    </span>
    <input
        #seconds
        *ngIf="format.seconds && units.controls.seconds"
        class="input"
        formControlName="seconds"
        aria-label="Hours"
        [size]="inputsConfiguration.seconds.size"
        (input)="onInput(secondsInput)"
    />
</div>
